import { getPlayerDataFieldName } from "../constants/stats";

const MISSING_STAT_TOKENS = new Set(["", "—", "-", ".---", "null", "undefined"]);

export function parseSeasonStatValue(raw) {
  if (raw == null) return null;
  const trimmed = String(raw).trim();
  if (MISSING_STAT_TOKENS.has(trimmed)) return null;
  const parsed = parseFloat(trimmed.replace(/,/g, ""));
  return Number.isFinite(parsed) ? parsed : null;
}

export function getSeasonStatValue(season, statType) {
  if (!season || !statType) return null;

  const mappedField = getPlayerDataFieldName(statType);
  const candidates = [mappedField, statType].filter(
    (field, index, fields) => fields.indexOf(field) === index
  );

  for (const field of candidates) {
    const value = parseSeasonStatValue(season[field]);
    if (value !== null) return value;
  }

  return null;
}

export function buildSeasonChartPoints(seasons, statType) {
  return Object.keys(seasons || {})
    .sort()
    .map((year) => ({
      year,
      value: getSeasonStatValue(seasons[year], statType),
    }));
}

export function seasonChartHasValues(points) {
  return (points || []).some((point) => point?.value !== null);
}
